import { memo } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import type { Setup } from "features/setups/types";


type Props = {
    row: Setup<string>;
    create: () => void;
}

const CreateGroup = ({ create }: Props) => {

    return (
        <ListItem disablePadding>
            <ListItemButton
                onPointerDown={create}
            >
                <ListItemText primary='Create Group' />
            </ListItemButton>
        </ListItem>
    );
};

export default memo(CreateGroup);